(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('documentParameterDefinitionsQueryRequest', function () {

        function queryRequest() {
            this.order = 'dopadeName';
            this.page = 1;
            this.limit = 5;
            this.search = {};
        }

        return queryRequest;
    });
})();
